import React from "react";
import PricingSection from "../Components/Reports/PricingSection";
import ProjectSection from "../Components/Reports/ProjectSection";
import SavingsSection from "../Components/Reports/SavingsSection";

export default function ReportsPage() {
  return (
    <div>
      <PricingSection />
      <SavingsSection />
      <ProjectSection />
    </div>
  );
}
